<template>
    <div>
        <b-tabs :nav-class="tabsNavClass">
            <b-tab :title="$t('Vue.Grid.OrdersGrid.TabLabel.CourtOrders')" :active="(initialTab == 'Court')" v-if="canViewCourtOrders" v-on:click="tabActivated(court)">
                <filter-ui :fields="court.filterFields" ref="ordersCourtFilter" :apiBaseUrl="apiBaseUrl" relatedTo="order-court" :filter="court.initialFilter" v-on:change="courtFilterChanged"></filter-ui>
                <ejs-grid id="ordersCourtGrid"
                          ref="courtGrid"
                          :dataSource="court.gridData"
                          :toolbar="toolbar"
                          :allowSorting="true"
                          :sortSettings="court.sortSettings"
                          :enableStickyHeader="true"
                          :allowGrouping="false"
                          :groupSettings="groupSettings"
                          :allowResizing="true"
                          :allowPaging="true"
                          :pageSettings="pageSettings"
                          :showColumnChooser="true"
                          :allowExcelExport="true"
                          :dataStateChange="courtGridDataStateChanged"
                          :queryCellInfo="customiseCell"
                          :excelQueryCellInfo="customiseCell"
                          :rowSelected="courtGridRowSelectionChanged"
                          :rowDeselected="courtGridRowSelectionChanged"
                          :toolbarClick="courtGridToolbarClicked"
                          :created="gridCreated(court)"
                          v-if="court.show"
                          :headerCellInfo="headerCellInfoEvent">
                    <e-columns>
                        <e-column field="epiqReferenceGridDisplay" headerText="Epiq #" width="100"></e-column>
                        <e-column field="courtMatterNumber" :allowSorting="false" :allowGrouping="false" :headerText="$t('Vue.Grid.Shared.HeaderText.MatterNumber')"></e-column>
                        <e-column field="courtRegistryName" headerText="Court/Tribunal/Other"></e-column>
                        <e-column field="courtMatterNameOrDescription" :headerText="$t('Vue.Grid.Shared.HeaderText.MatterNameOrDescription')"></e-column>
                        <e-column field="sittingDateDisplayText" headerText="First Sitting Date"></e-column>
                        <e-column field="restrictedDisplayText" headerText="Restricted Mode"></e-column>
                        <e-column field="orderNumberDisplayText" headerText="Order #"></e-column>
                        <e-column field="orderingClientName" headerText="Ordering Client"></e-column>
                        <e-column field="clientReference" headerText="Client Reference" :template="relatedSittingsClientReferenceColumnTemplate"></e-column>
                        <e-column field="serviceTypeName" headerText="Service Type"></e-column>
                        <e-column field="serviceDelayName" headerText="Turnaround" v-if="canViewTurnaround"></e-column>
                        <e-column field="statusDisplayName" headerText="Status" :allowSorting="false" :allowGrouping="false"></e-column>
                        <e-column field="subStatusDeliveryStateText" headerText="Sub Status" :template="orderSubStatusColumnTemplate" :allowSorting="false" :allowGrouping="false"></e-column>
                        <e-column field="createdDateTimeUTC" :headerText="$t('Entities.Shared.CreatedDateTimeUTC')"></e-column>
                        <e-column field="effectiveLastUpdateDateTimeUTC" headerText="Last Update"></e-column>
                        <e-column field="confirmedDateTimeUTC" :headerText="$t('Entities.Order.ConfirmedDateTimeUTC')"></e-column>
                        <e-column field="createdByUserAccountDisplayName" headerText=" Created By" :allowSorting="false" :allowGrouping="false"></e-column>
                        <e-column field="confirmedByUserAccountDisplayName" headerText="Confirmed By" :allowSorting="false" :allowGrouping="false"></e-column>
                    </e-columns>
                </ejs-grid>
            </b-tab>
            <b-tab :title="$t('Vue.Grid.OrdersGrid.TabLabel.InterviewOrders')" :active="(initialTab == 'Interview')" v-if="canViewInterviewOrders" v-on:click="tabActivated(interview)">
                <filter-ui :fields="interview.filterFields" ref="ordersInterviewFilter" :apiBaseUrl="apiBaseUrl" relatedTo="order-interview" :filter="interview.initialFilter" v-on:change="interviewFilterChanged"></filter-ui>
                <ejs-grid id="ordersInterviewGrid"
                          ref="interviewGrid"
                          :dataSource="interview.gridData"
                          :toolbar="toolbar"
                          :allowSorting="true"
                          :enableStickyHeader="true"
                          :sortSettings="interview.sortSettings"
                          :allowGrouping="false"
                          :groupSettings="groupSettings"
                          :allowResizing="true"
                          :allowPaging="true"
                          :pageSettings="pageSettings"
                          :showColumnChooser="true"
                          :allowExcelExport="true"
                          :dataStateChange="interviewGridDataStateChanged"
                          :queryCellInfo="customiseCell"
                          :excelQueryCellInfo="customiseCell"
                          :rowSelected="interviewGridRowSelectionChanged"
                          :rowDeselected="interviewGridRowSelectionChanged"
                          :toolbarClick="interviewGridToolbarClicked"
                          :created="gridCreated(interview)"
                          v-if="interview.show"
                          :headerCellInfo="headerCellInfoEvent">
                    <e-columns>
                        <e-column field="epiqReference" headerText="Epiq #" width="100"></e-column>
                        <e-column field="interviewOrganisationName" headerText="Organisation"></e-column>
                        <e-column field="interviewDateTime" headerText="Date/Time of Interview"></e-column>
                        <e-column field="interviewLocation" headerText="Location"></e-column>
                        <e-column field="interviewersDisplayText" headerText="Interviewer/s" :allowSorting="false" :allowGrouping="false"></e-column>
                        <e-column field="intervieweesDisplayText" headerText="Interviewee/s" :allowSorting="false" :allowGrouping="false"></e-column>
                        <e-column field="orderNumberDisplayText" headerText="Order #"></e-column>
                        <e-column field="orderingClientName" headerText="Ordering Client"></e-column>
                        <e-column field="clientReference" headerText="Client Reference" :template="relatedSittingsClientReferenceColumnTemplate"></e-column>
                        <e-column field="serviceTypeName" headerText="Service Type"></e-column>
                        <e-column field="serviceDelayName" headerText="Turnaround" v-if="canViewTurnaround"></e-column>
                        <e-column field="statusDisplayName" headerText="Status" :allowSorting="false" :allowGrouping="false"></e-column>
                        <e-column field="subStatusDeliveryStateText" headerText="Sub Status" :template="orderSubStatusColumnTemplate" :allowSorting="false" :allowGrouping="false"></e-column>
                        <e-column field="createdDateTimeUTC" :headerText="$t('Entities.Shared.CreatedDateTimeUTC')"></e-column>
                        <e-column field="effectiveLastUpdateDateTimeUTC" headerText="Last Update"></e-column>
                        <e-column field="confirmedDateTimeUTC" :headerText="$t('Entities.Order.ConfirmedDateTimeUTC')"></e-column>
                        <e-column field="createdByUserAccountDisplayName" headerText=" Created By" :allowSorting="false" :allowGrouping="false"></e-column>
                        <e-column field="confirmedByUserAccountDisplayName" headerText="Confirmed By" :allowSorting="false" :allowGrouping="false"></e-column>
                    </e-columns>
                </ejs-grid>
            </b-tab>
        </b-tabs>

        <validation-observer v-slot="{ passes }" slim>
            <b-modal size="md"
                     centered
                     title="Cancel Order"
                     ok-title="Yes, Cancel"
                     cancel-title="No, Keep Order"
                     v-model="disableOrderDialogShown"
                     v-on:ok.prevent="passes(disableOrder)">
                <b-alert v-model="showErrors" variant="danger" dismissible>
                    <div v-for="(error, index) in currentErrors" :key="index">
                        <p>{{ error }}</p>
                    </div>
                </b-alert>
                <p>Are you sure you want to cancel the order?</p>
                <p v-if="currentOrder && currentOrder.courtRegistry"><strong>Court/Tribunal/Other:</strong>&nbsp;{{ currentOrder.courtRegistry.name }}</p>
                <p v-if="currentOrder && currentOrder.courtMatter"><strong>Matter:</strong>&nbsp;{{ currentOrder.courtMatter.displayName }}</p>
                <p v-if="currentOrder && currentOrder.interviewOrganisation"><strong>Organisation:</strong>&nbsp;{{ currentOrder.interviewOrganisation.name }}</p>
                <p v-if="currentOrder && currentOrder.interview"><strong>Interview:</strong>&nbsp;{{ currentOrder.interview.displayName }}</p>
                <p v-if="currentOrder && currentOrder.orderingClient"><strong>Ordering Client:</strong>&nbsp;{{ currentOrder.orderingClient.name }}</p>
                <p>This action cannot be undone!</p>
                <b-form-row>
                    <validation-provider rules="required" name="Reason" v-slot="{ valid, errors }" slim>
                        <b-form-group label="Reason"
                                      label-for="disableReason"
                                      class="col">
                            <b-form-textarea name="disableReason"
                                             autofocus
                                             v-model="disableReason"
                                             :state="errors[0] ? false : null">
                            </b-form-textarea>
                            <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                        </b-form-group>
                    </validation-provider>
                </b-form-row>
            </b-modal>
        </validation-observer>

        <b-modal size="md"
                 centered
                 title="Copy Order"
                 ok-title="Yes, Copy"
                 cancel-title="No, Do Not Copy"
                 v-model="copyOrderDialogShown"
                 v-on:ok="copyOrder">
            <b-form-row>
                <b-form-group label="What information do you want to copy?">
                    <b-form-radio-group v-model="selectedCopyOrderType"
                                        :options="copyOrderTypeOptions"
                                        stacked>
                    </b-form-radio-group>
                </b-form-group>
            </b-form-row>
        </b-modal>
    </div>
</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import { GridPlugin, ColumnChooser, Resize, Sort, Group, Page, Toolbar, Search, ExcelExport } from '@syncfusion/ej2-vue-grids';
    import { TooltipPlugin } from "@syncfusion/ej2-vue-popups";
    import { DataManager } from "@syncfusion/ej2-data";
    import axios from 'axios';
    import Visibility from 'visibilityjs';
    import OrderSubStatusColumnTemplate from './OrderSubStatusColumnTemplate';
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import { extend, localize } from 'vee-validate';
    import { required } from 'vee-validate/dist/rules';
    import en from 'vee-validate/dist/locale/en.json';
    import RelatedSittingsClientReferenceColumnTemplate from './RelatedSittingsClientReferenceColumnTemplate';
    extend('required', required);
    localize('en', en);

    import FilterUI from './FilterUI';
    import ErrorsMixin from '../../mixins/ErrorsMixin';
    import DateTimeMixin from '../../mixins/DateTimeMixin';
    import GridMixins from '../../mixins/GridMixins';

    Vue.use(BootstrapVue);
    Vue.use(GridPlugin);
    Vue.use(TooltipPlugin);

    //this is required to make the getGroupCaption function available globally and thus within the groupCaptionTemplate
    var ordersGrid_vueComponent = null;
    function ordersGrid_getGroupCaption(field, headerText, value) {
        return ordersGrid_vueComponent.getGroupCaption(field, headerText, value);
    }
    window.ordersGrid_getGroupCaption = ordersGrid_getGroupCaption;

    export default {
        name: 'OrdersGrid',
        mixins: [ErrorsMixin, DateTimeMixin, GridMixins],
        components: {
            'validation-provider': ValidationProvider,
            'validation-observer': ValidationObserver,
            'filter-ui': FilterUI,
        },
        provide: {
            grid: [ColumnChooser, Resize, Sort, Group, Page, Toolbar, Search, ExcelExport]
        },
        props: {
            apiBaseUrl: {
                type: String,
                required: true
            },
            pagesBaseUrl: {
                type: String,
                required: true
            },
            canViewCourtOrders: {
                type: Boolean,
                default: false
            },
            canViewInterviewOrders: {
                type: Boolean,
                default: false
            },
            canViewOrderDetails: {
                type: Boolean,
                default: false
            },
            canViewWorkItems: {
                type: Boolean,
                default: false
            },
            canViewTurnaround: {
                type: Boolean,
                default: false
            },
            canConfirmOrders: {
                type: Boolean,
                default: false
            },
            canUnconfirmOrders: {
                type: Boolean,
                default: false
            },
            canCopyOrders: {
                type: Boolean,
                default: false
            },
            canDeleteOrders: {
                type: Boolean,
                default: false
            },
            allCourtRegistryOptions: {
                type: Array,
                default: null
            },
            allInterviewOrganisationOptions: {
                type: Array,
                default: null
            },
            allOrderingClientOptions: {
                type: Array,
                default: null
            },
            allServiceTypeOptions: {
                type: Array,
                default: null
            },
            allServiceDelayOptions: {
                type: Array,
                default: null
            },
            allOrderStatusOptions: {
                type: Array,
                default: null
            },
            allStaffCreatedByOptions: {
                type: Array,
                default: null
            },
            allStaffConfirmedByOptions: {
                type: Array,
                default: null
            },
            courtRelatedWorkItemOptions: {
                type: Array,
                default: null
            },
            initialCourtRelatedWorkItemId: {
                type: String,
                default: null
            },
            interviewRelatedWorkItemOptions: {
                type: Array,
                default: null
            },
            initialInterviewRelatedWorkItemId: {
                type: String,
                default: null
            },
            initialTab: {
                type: String,
                default: null
            }
        },
        data: function () {
            return {
                orderSubStatusColumnTemplate: function () {
                    return { template: OrderSubStatusColumnTemplate }
                },

                relatedSittingsClientReferenceColumnTemplate: function () {
                    return { template: RelatedSittingsClientReferenceColumnTemplate }
                },

                groupSettings: { showGroupedColumn: true, disablePageWiseAggregates: true, captionTemplate: "${ordersGrid_getGroupCaption(field, headerText, key)}" },
                pageSettings: { pageSize: 10, pageSizes: [5, 10, 25, 50] },

                court: {
                    name: "court",
                    initialized: false,
                    dataLoaded: false,
                    show: true,
                    filterFields: [
                        {
                            field: "CourtRegistryId",
                            label: "Court/Tribunal/Other",
                            type: "multiselect",
                            options: this.allCourtRegistryOptions,
                            placeholder: "Select Court/Tribunal/Other Values"
                        },
                        {
                            field: "SittingDate",
                            label: "Sitting Date",
                            type: "date",
                            format: "dd/MM/yyyy"
                        },
                        {
                            field: "OrderingClientId",
                            label: "Ordering Client",
                            type: "multiselect",
                            options: this.allOrderingClientOptions,
                            placeholder: "Select Ordering Client"
                        },
                        {
                            field: "OrderedDate",
                            label: "Ordered Date",
                            type: "date",
                            format: "dd/MM/yyyy"
                        },
                        {
                            field: "CompletedDate",
                            label: "Date Delivered",
                            type: "date",
                            format: "dd/MM/yyyy"
                        },
                        {
                            field: "CreatedDateTimeUTC",
                            label: "Created Date",
                            type: "date",
                            format: "dd/MM/yyyy"
                        },
                        {
                            field: "ConfirmedDateTimeUTC",
                            label: "Confirmed Date",
                            type: "date",
                            format: "dd/MM/yyyy"
                        },
                        {
                            field: "ServiceTypeId",
                            label: "Service Type",
                            type: "multiselect",
                            options: this.allServiceTypeOptions,
                            placeholder: "Select Service Types"
                        },
                        {
                            field: "ServiceDelayId",
                            label: "Turnaround",
                            type: "multiselect",
                            options: this.allServiceDelayOptions,
                            placeholder: "Select Turnaround Values"
                        },
                        {
                            field: "Status",
                            label: "Status",
                            type: "multiselect",
                            options: this.allOrderStatusOptions,
                            placeholder: "Select Status Values"
                        },
                        {
                            field: "WorkItemId",
                            label: "Worksheet",
                            type: "multiselect",
                            options: this.courtRelatedWorkItemOptions
                        },
                        {
                            field: "CreatedByUserId",
                            label: "Created By",
                            type: "multiselect",
                            options: this.allStaffCreatedByOptions
                        },
                        {
                            field: "ConfirmedByUserId",
                            label: "Confirmed By",
                            type: "multiselect",
                            options: this.allStaffConfirmedByOptions
                        },
                        {
                            field: "Restricted",
                            label: "Restricted Mode",
                            type: "boolean",
                            options: [{ value: false, text: "Not Restricted" }, { value: true, text: "Restricted" }]
                        }
                    ],
                    quickFilters: null,
                    initialFilter: null,

                    sortSettings: { columns: [{ field: "effectiveLastUpdateDateTimeUTC", direction: "Descending" }] },
                    gridDataState: {
                        filter: null,
                        search: null,
                        sorted: [{ name: "effectiveLastUpdateDateTimeUTC", direction: "descending" }],
                        group: null,
                        skip: 0,
                        take: 10,
                        requiresCounts: true
                    },
                    gridData: { result: [], count: 0 },
                    grid: null
                },

                interview: {
                    name: "interview",
                    initialized: false,
                    dataLoaded: false,
                    show: true,
                    filterFields: [
                        {
                            field: "InterviewOrganisationId",
                            label: "Organisation",
                            type: "multiselect",
                            options: this.allInterviewOrganisationOptions,
                            placeholder: "Select Organisations"
                        },
                        {
                            field: "InterviewDate",
                            label: "Date of Interview",
                            type: "date",
                            format: "dd/MM/yyyy"
                        },
                        {
                            field: "OrderingClientId",
                            label: "Ordering Client",
                            type: "multiselect",
                            options: this.allOrderingClientOptions,
                            placeholder: "Select Ordering Client"
                        },
                        {
                            field: "OrderedDate",
                            label: "Ordered Date",
                            type: "date",
                            format: "dd/MM/yyyy"
                        },
                        {
                            field: "CompletedDate",
                            label: "Date Delivered",
                            type: "date",
                            format: "dd/MM/yyyy"
                        },
                        {
                            field: "CreatedDate",
                            label: "Created Date",
                            type: "date",
                            format: "dd/MM/yyyy"
                        },
                        {
                            field: "ConfirmedDateTimeUTC",
                            label: "Confirmed Date",
                            type: "date",
                            format: "dd/MM/yyyy"
                        },
                        {
                            field: "ServiceTypeId",
                            label: "Service Type",
                            type: "multiselect",
                            options: this.allServiceTypeOptions,
                            placeholder: "Select Service Types"
                        },
                        {
                            field: "ServiceDelayId",
                            label: "Turnaround",
                            type: "multiselect",
                            options: this.allServiceDelayOptions,
                            placeholder: "Select Turnaround Values"
                        },
                        {
                            field: "Status",
                            label: "Status",
                            type: "multiselect",
                            options: this.allOrderStatusOptions,
                            placeholder: "Select Status Values"
                        },
                        {
                            field: "WorkItemId",
                            label: "Worksheet",
                            type: "multiselect",
                            options: this.interviewRelatedWorkItemOptions
                        },
                    ],
                    quickFilters: null,
                    initialFilter: null,

                    sortSettings: { columns: [{ field: "effectiveLastUpdateDateTimeUTC", direction: "Descending" }] },
                    gridDataState: {
                        filter: null,
                        search: null,
                        sorted: [{ name: "effectiveLastUpdateDateTimeUTC", direction: "descending" }],
                        group: null,
                        skip: 0,
                        take: 10,
                        requiresCounts: true
                    },
                    gridData: { result: [], count: 0 },
                    grid: null
                },
                currentOrder: null,
                currentGrid: null,
                disableOrderDialogShown: false,
                showErrors: false,
                currentErrors: null,
                disableReason: null,

                timer: null,
                refreshIntervalInMilliseconds: 3000,

                copyOrderDialogShown: false,
                copyOrderTypeOptions: [
                    { text: 'Only basic information', value: 'Basic' },
                    { text: 'Everything', value: 'Everything' }
                ],
                selectedCopyOrderType: 'Basic',

                columnFormats: {
                    interviewDateTime: {
                        type: 'datetime',
                        options: {
                            mode: 'checktimeincludeseconds',
                            outputAsUTC: true
                        }
                    },
                    createdDateTimeUTC: {
                        type: 'datetime'
                    },
                    effectiveLastUpdateDateTimeUTC: {
                        type: 'datetime'
                    },
                    confirmedDateTimeUTC: {
                        type: 'datetime'
                    },
                    courtMatterFirstSittingDate: {
                        type: 'datetime',
                        options: {
                            mode: 'excludetime',
                            outputAsUTC: true
                        }
                    }
                },
            }
        },
        computed: {
            tabsNavClass: function () {
                var tabsNavClass = "border-bottom-0";
                if (!this.canViewCourtOrders || !this.canViewInterviewOrders) tabsNavClass += " d-none";
                return tabsNavClass;
            },
            toolbar: function () {
                var toolbarItems = this.defaultEJ2DataGridToolbarItems();
                if (this.canViewOrderDetails) {
                    toolbarItems =
                        toolbarItems.concat(
                            [
                                { text: "Open", tooltipText: "Open selected Order Details", prefixIcon: "fas fa-file-alt", id: "orderdetails", cssClass: "orderdetails" },
                            ]
                        );
                }
                if (this.canConfirmOrders) {
                    toolbarItems =
                        toolbarItems.concat(
                            [
                                { text: "Confirm", tooltipText: "Confirm selected Order", prefixIcon: "fas fa-check", id: "confirmorder", cssClass: "confirmorder" },
                            ]
                        );
                }
                if (this.canViewWorkItems) {
                    toolbarItems =
                        toolbarItems.concat(
                            [
                                { text: "Worksheets", tooltipText: "View Worksheets related to selected Order", prefixIcon: "fas fa-tasks", id: "orderworksheets", cssClass: "orderworksheets" },
                            ]
                        );
                }
                if (this.canUnconfirmOrders) {
                    toolbarItems =
                        toolbarItems.concat(
                            [
                                { text: "Modify", tooltipText: "Modify selected Order", prefixIcon: "fas fa-edit", id: "unconfirmorder", cssClass: "unconfirmorder" },
                            ]
                        );
                }
                if (this.canDeleteOrders) {
                    toolbarItems =
                        toolbarItems.concat(
                            [
                                { text: "Cancel", tooltipText: "Cancel selected Order", prefixIcon: "fas fa-times", id: "disableorder", cssClass: "disableorder" },
                            ]
                        );
                }
                if (this.canCopyOrders) {
                    toolbarItems =
                        toolbarItems.concat(
                            [
                                { text: "Copy", tooltipText: "Copy selected Order", prefixIcon: "fas fa-copy", id: "copyorder", cssClass: "copyorder" },
                            ]
                        );
                }
                return toolbarItems;
            }
        },
        methods: {
            getGroupCaption: function (field, headerText, value) {
                if (field == "courtMatterFirstSittingDate") value = this.dateTimeDisplayString(value, 'excludetime', true, true);
                else if (field == "interviewDateTime") value = this.dateTimeDisplayString(value, 'checktimeincludeseconds', true, true);
                else if (field == "createdDateTimeUTC") value = this.dateTimeDisplayString(value, 'includetime', true, false);
                else if (field == "effectiveLastUpdateDateTimeUTC") value = this.dateTimeDisplayString(value, 'includetime', true, false);
                return headerText + ": " + value;
            },
            customizeGroupKeys(groupedDate) {
                groupedDate.forEach(g => {
                    if (g.field && g.key && g.items) {
                        if (g.field == "courtMatterFirstSittingDate") g.key = this.dateTimeDisplayString(g.key, 'excludetime', true, true);
                        else if (g.field == "interviewDateTime") g.key = this.dateTimeDisplayString(g.key, 'checktimeincludeseconds', true, true);
                        else if (g.field == "createdDateTimeUTC") g.key = this.dateTimeDisplayString(g.key, 'includetime', true, false);
                        else if (g.field == "effectiveLastUpdateDateTimeUTC") g.key = this.dateTimeDisplayString(g.key, 'includetime', true, false);
                        else if (g.field == "confirmedDateTimeUTC") g.key = this.dateTimeDisplayString(g.key, 'includetime', true, false);
                        this.customizeGroupKeys(g.items);
                    }
                });
            },
            customiseCell: function (args) {
                if ((args.column.field == 'epiqReferenceCourtMatterNumber') && (args.name == 'queryCellInfo')) {
                    args.cell.innerHTML = "<a href='" + this.pagesBaseUrl + '/Orders/Edit/' + args.data.orderId + "' target='_blank'>" + args.data.epiqReferenceCourtMatterNumber + "</a>";
                } else if ((args.column.field == 'epiqReference') && (args.name == 'queryCellInfo')) {
                    args.cell.innerHTML = "<a href='" + this.pagesBaseUrl + '/Orders/Edit/' + args.data.orderId + "' target='_blank'>" + args.data.epiqReference + "</a>";
                } else if ((args.column.field == 'epiqReferenceGridDisplay') && (args.name == 'queryCellInfo')) {
                    args.cell.innerHTML = "<a href='" + this.pagesBaseUrl + '/Orders/Edit/' + args.data.orderId + "' target='_blank'>" + args.data.epiqReferenceGridDisplay + "</a>";
                } else if ((args.column.field === 'restrictedDisplayText') && (args.name != 'excelQueryCellInfo')) {
                    var restricted = args.data['restricted'];
                    if (restricted === true) {
                        args.cell.classList.add('order-restricted');
                    }
                } else {
                    this.defaultEJ2DataGridQueryCellInfo(args, this.columnFormats);
                }
            },

            courtFilterChanged: function (filter) {
                this.filterChanged(this.court, filter);
            },
            courtGridDataStateChanged: function (args) {
                this.gridDataStateChanged(this.court, args);
            },
            courtGridRowSelectionChanged: function (args) {
                this.rowSelectionChanged(this.court.grid, args);
            },
            courtGridToolbarClicked: function (args) {
                this.toolbarClicked(this.court, args);
            },

            interviewFilterChanged: function (filter) {
                this.filterChanged(this.interview, filter);
            },
            interviewGridDataStateChanged: function (args) {
                this.gridDataStateChanged(this.interview, args);
            },
            interviewGridRowSelectionChanged: function (args) {
                this.rowSelectionChanged(this.interview.grid, args);
            },
            interviewGridToolbarClicked: function (args) {
                this.toolbarClicked(this.interview, args);
            },
            filterChanged: function (relatedTo, filter) {
                relatedTo.gridDataState.filter = filter;
                if (relatedTo.initialized) relatedTo.grid.refresh();
            },
            gridDataStateChanged: function (relatedTo, args) {
                relatedTo.gridDataState.search = args.search;
                relatedTo.gridDataState.sorted = args.sorted;
                relatedTo.gridDataState.group = args.group;
                relatedTo.gridDataState.skip = args.skip;
                relatedTo.gridDataState.take = args.take;
                relatedTo.gridDataState.requiresCounts = args.requiresCounts;
                if (relatedTo.initialized) {
                    relatedTo.grid.showSpinner();
                    this.loadOrders(relatedTo.name, relatedTo.gridDataState)
                        .then(result => {
                            if (result) {
                                relatedTo.gridData = result;
                            }
                            relatedTo.grid.hideSpinner();
                        });
                }
            },
            rowSelectionChanged: function (grid, args) {
                if (args.name == 'rowSelected') {
                    this.updateToolbarItems(grid, grid.getSelectedRecords()[0])
                } else {
                    this.updateToolbarItems(grid, null)
                }
            },
            updateToolbarItems: function (grid, order) {
                if (this.canViewOrderDetails) {
                    this.setToolbarItemState(grid, 'orderdetails', (order != null));
                }
                if (this.canConfirmOrders) {
                    this.setToolbarItemState(grid, 'confirmorder', (order != null) && (order.confirmedDateTimeUTC == null) && (order.disabledDateTimeUTC == null));
                }
                if (this.canViewWorkItems) {
                    this.setToolbarItemState(grid, 'orderworksheets', (order != null) && (order.confirmedDateTimeUTC != null));
                }
                if (this.canUnconfirmOrders) {
                    this.setToolbarItemState(grid, 'unconfirmorder', (order != null) && order.unconfirmAllowed);
                }
                if (this.canDeleteOrders) {
                    this.setToolbarItemState(grid, 'disableorder', (order != null) && order.disableAllowed);
                }
                if (this.canCopyOrders) {
                    this.setToolbarItemState(grid, 'copyorder', (order != null));
                }
                this.setToolbarItemState(grid, 'orderactionsseparator', (order != null));
            },
            setToolbarItemState: function (grid, itemClass, enabled) {
                grid.toolbarModule.enableItems([itemClass], enabled);
            },
            toolbarClicked: function (relatedTo, args) {

                if ((args.item.id === 'orderdetails') ||
                    (args.item.id === 'confirmorder') ||
                    (args.item.id === 'orderworksheets') ||
                    (args.item.id === 'unconfirmorder') ||
                    (args.item.id === 'disableorder') ||
                    (args.item.id === 'copyorder')) {
                    this.handleAction(args.item.id, relatedTo.grid.getSelectedRecords()[0], relatedTo.grid);
                } else if (args.item.id === 'excelexport') {
                    //to properly export all data (and not just the entries displayed on the current page) we have to load everything first
                    //we do this by taking the current grid state (which includes the current filter and search and sort settings)
                    var gridDataState = {
                        ...relatedTo.gridDataState
                    };
                    //but reset the skip and take to 0 which will return everything and unset the requiresCounts cause we are not interseted in the totals
                    gridDataState.requiresCounts = false;
                    relatedTo.grid.showSpinner();
                    this.loadOrders(relatedTo.name, gridDataState)
                        .then(result => {
                            //the result is either false if something failed during the axios request, or it will contain the list in the result property which is what we have to pass to the actual export
                            if (result) {
                                var query = relatedTo.grid.getDataModule().generateQuery(true);
                                var groupedData = new DataManager(result.result).executeLocal(query);
                                this.customizeGroupKeys(groupedData);
                                relatedTo.grid.excelExport({ dataSource: groupedData });
                            }
                            relatedTo.grid.hideSpinner();
                        });
                } else if (args.item.id === 'reset') {
                    this.deleteGridSettings(relatedTo.grid)
                        .then(() => {
                            relatedTo.gridDataState.search = "";
                            relatedTo.show = false;
                            Vue.nextTick(() => {
                                relatedTo.show = true;
                                Vue.nextTick(() => {
                                    relatedTo.grid = (relatedTo.name == "court") ? this.$refs.courtGrid.ej2Instances : this.$refs.interviewGrid.ej2Instances;
                                    this.setupGridPersistence(relatedTo.grid);
                                    this.updateToolbarItems(relatedTo.grid, null);
                                    relatedTo.grid.refresh();
                                });
                            });
                        });
                } else {
                    this.defaultEJ2DataGridToolbarClickHandler(args, relatedTo.grid);
                }
            },
            reloadDummy: function () {
                console.log('reloading grid.')
            },
            handleAction: function (action, order, grid) {

                // stop the timer when opening a dialog
                if (this.timer != null) {
                    Visibility.stop(this.timer);
                    this.timer = null;
                }
                if (order) {
                    var orderDetails = "<div>";
                    if (order.courtRegistry && order.courtRegistry.name) orderDetails += "<p><strong>Court/Tribunal/Other:</strong>&nbsp;" + order.courtRegistry.name + "</p>";
                    if (order.courtMatter && order.courtMatter.displayName) orderDetails += "<p><strong>Matter:</strong>&nbsp;" + order.courtMatter.displayName + "</p>";
                    if (order.interviewOrganisation && order.interviewOrganisation.name) orderDetails += "<p><strong>Organisation:</strong>&nbsp;" + order.interviewOrganisation.name + "</p>";
                    if (order.interview && order.interview.displayName) orderDetails += "<p><strong>Interview:</strong>&nbsp;" + order.interview.displayName + "</p>";
                    if (order.orderingClient && order.orderingClient.name) orderDetails += "<p><strong>Ordering Client:</strong>&nbsp;" + order.orderingClient.name + "</p>";
                    orderDetails += "</div>";
                    if (action === 'orderdetails') {
                        window.open(this.pagesBaseUrl + '/Orders/Edit/' + order.orderId);
                    } else if (action === 'confirmorder') {

                        this.$bvModal.msgBoxConfirm(
                            [
                                this.$createElement(
                                    'div',
                                    {
                                        domProps:
                                        {
                                            innerHTML: "<p>Are you sure you want to confirm the order?</p>" + orderDetails
                                        }
                                    }
                                )
                            ],
                            {
                                title: 'Confirm Order',
                                size: 'md',
                                okVariant: 'danger',

                                okTitle: 'Yes, Confirm',
                                cancelTitle: 'No, Keep Unconfirmed',
                                centered: true
                            })
                            .then(value => {
                                this.timer = Visibility.every(this.refreshIntervalInMilliseconds, this.reloadDummy);
                                if (value) {
                                    this.confirmOrder(order.orderId, grid);
                                }
                            });

                    } else if (action === 'orderworksheets') {
                        window.open(this.pagesBaseUrl + '/WorkItems/' + order.orderId);
                    } else if (action === 'unconfirmorder') {
                        this.$bvModal.msgBoxConfirm(
                            [
                                this.$createElement(
                                    'div',
                                    {
                                        domProps:
                                        {
                                            innerHTML: "<p>Are you sure you want to modify the order?</p>" + orderDetails + "<p>This action will revert the previous confirmation and bring the order back into an unconfirmed state. All related Worksheets will be removed. Once the order has been modified it has to be confirmed again!</p>"
                                        }
                                    }
                                )
                            ],
                            {
                                title: 'Modify Order',
                                size: 'md',
                                okVariant: 'danger',
                                okTitle: 'Yes, Modify',

                                cancelTitle: 'No, Keep Confirmed',
                                centered: true
                            })
                            .then(value => {
                                this.timer = Visibility.every(this.refreshIntervalInMilliseconds, this.reloadDummy);
                                if (value) {
                                    this.unconfirmOrder(order.orderId, grid);
                                }
                            });
                    } else if (action === 'disableorder') {
                        this.currentOrder = order;
                        this.currentGrid = grid;
                        this.currentErrors = null;
                        this.showErrors = false;
                        this.disableReason = null;
                        this.disableOrderDialogShown = true;
                    } else if (action === 'copyorder') {
                        this.currentOrder = order;
                        this.currentGrid = grid;
                        this.currentErrors = null;
                        this.showErrors = false;
                        this.selectedCopyOrderType = this.copyOrderTypeOptions[0].value;
                        this.copyOrderDialogShown = true;
                    }
                }
            },
            loadOrders: function (relatedToName, gridDataState) {
                var url = this.apiBaseUrl + '/order/list/' + relatedToName;
                return axios
                    .post(url, JSON.stringify(gridDataState), {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(response => {
                        var gridData = response.data;
                        if (gridData && gridData.result) {
                            gridData.result = gridData.result.map((order) => {
                                if (order.courtMatterFirstSittingDate) order.courtMatterFirstSittingDate = this.parseDateTime(order.courtMatterFirstSittingDate, true, true);
                                if (order.interviewDateTime) order.interviewDateTime = this.parseDateTime(order.interviewDateTime, true, true);
                                if (order.createdDateTimeUTC) order.createdDateTimeUTC = this.parseDateTime(order.createdDateTimeUTC, true, false);
                                if (order.effectiveLastUpdateDateTimeUTC) order.effectiveLastUpdateDateTimeUTC = this.parseDateTime(order.effectiveLastUpdateDateTimeUTC, true, false);
                                if (order.confirmedDateTimeUTC) order.confirmedDateTimeUTC = this.parseDateTime(order.confirmedDateTimeUTC, true, false);
                                return order;
                            });
                        }
                        return gridData;
                    })
                    .catch(ex => {
                        var errors = this.handleAxiosException(ex);
                        this.showErrorsToast(errors);
                        return false;
                    });
            },
            confirmOrder: function (orderId, grid) {
                var url = this.apiBaseUrl + '/order/' + orderId + '/confirm';
                axios
                    .get(url)
                    .catch(ex => {
                        var errors = this.handleAxiosException(ex);
                        this.showErrorsToast(errors);
                    })
                    .finally(() => {
                        grid.refresh();
                    });
            },
            unconfirmOrder: function (orderId, grid) {
                var url = this.apiBaseUrl + '/order/' + orderId + '/unconfirm';
                axios
                    .get(url)
                    .then(() => {
                        window.open(this.pagesBaseUrl + '/Orders/Edit/' + orderId);
                    })
                    .catch(ex => {
                        var errors = this.handleAxiosException(ex);
                        this.showErrorsToast(errors);
                        grid.refresh();
                    });
            },
            disableOrder: function () {
                var url = this.apiBaseUrl + '/order/' + this.currentOrder.orderId + '/disable';
                axios
                    .post(url, JSON.stringify(this.disableReason), {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(() => {
                        this.currentOrder = null;
                        this.disableOrderDialogShown = false;
                        this.showErrors = false;
                        this.currentErrors = null;
                        this.disableReason = null;
                        this.currentGrid.refresh();
                        this.currentGrid = null;
                    })
                    .catch(ex => {
                        this.currentErrors = this.handleAxiosException(ex);
                        this.showErrors = true;
                    });
            },
            copyOrder: function () {
                var orderId = this.currentOrder.orderId;
                var copyOrderType = this.selectedCopyOrderType;
                var url = this.pagesBaseUrl + '/Orders/Copy/' + orderId + '/' + copyOrderType;
                this.currentOrder = null;
                this.selectedCopyOrderType = null;
                this.copyOrderDialogShown = false;
                Vue.nextTick(() => {
                    window.open(url);
                });
            },
            tabActivated: function (relatedTo) {
                if (!relatedTo.dataLoaded) {
                    relatedTo.grid.refresh();
                    relatedTo.dataLoaded = true;
                }
            },
            gridCreated: function (relatedTo) {
                Vue.nextTick(() => {
                    this.defaultEJ2DataGridCreatedHandler(relatedTo.grid);
                });
            }
        },
        mounted: function () {
            ordersGrid_vueComponent = this;
            if (this.canViewCourtOrders) {
                this.court.grid = this.$refs.courtGrid.ej2Instances;
                this.setupGridPersistence(this.court.grid);
                this.updateToolbarItems(this.court.grid, null);
                if (this.initialCourtRelatedWorkItemId) {
                    this.court.initialFilter = {
                        condition: "and",
                        rules: [
                            {
                                field: "WorkItemId",
                                operator: "in",
                                value: [this.initialCourtRelatedWorkItemId]
                            }
                        ]
                    }
                    this.court.gridDataState.filter = this.court.initialFilter;
                    this.court.gridDataState.search = "";
                    this.court.grid.search("");
                }
                this.$refs.ordersCourtFilter.loadQuickFilters()
                    .then(() => {
                        this.court.initialized = true;
                        if (this.initialTab == 'Court') {
                            setTimeout(() => {
                                this.court.grid.refresh();
                                this.court.dataLoaded = true;
                            }, 250);
                        }
                    });
            }
            if (this.canViewInterviewOrders) {
                this.interview.grid = this.$refs.interviewGrid.ej2Instances;
                this.setupGridPersistence(this.interview.grid);
                this.updateToolbarItems(this.interview.grid, null);
                if (this.initialInterviewRelatedWorkItemId) {
                    this.interview.initialFilter = {
                        condition: "and",
                        rules: [
                            {
                                field: "WorkItemId",
                                operator: "in",
                                value: [this.initialInterviewRelatedWorkItemId]
                            }
                        ]
                    }
                    this.interview.gridDataState.filter = this.interview.initialFilter;
                    this.interview.gridDataState.search = "";
                    this.interview.grid.search("");
                }
                this.$refs.ordersInterviewFilter.loadQuickFilters()
                    .then(() => {
                        this.interview.initialized = true;
                        if (this.initialTab == 'Interview') {
                            setTimeout(() => {
                                this.interview.grid.refresh();
                                this.interview.dataLoaded = true;
                            }, 250);
                        }
                    });
            }

            this.timer = Visibility.every(this.refreshIntervalInMilliseconds, this.reloadDummy);
            console.log('initial filter ', JSON.stringify(this.court.initialFilter));

        }
    }
</script>
<style scoped>
    div > > > .order-restricted {
        color: red !important;
    }
</style>